<template>
  <div id="form-task-new" class="task task_new">
    <div class="task__row task-summary">
      <div class="task__col">
        <div class="task-summary__title">
          <input
            type="text"
            class="form-input"
            :aria-invalid="corruptedFields.includes('name')"
            placeholder="Название задачи"
            :value="editable.task.name"
            @input="e => setEditable('name', e.target.value, 'task')"
          >
        </div>
        <div class="task-prop">
          <strong>Постановщик задачи:</strong>
          <div class="task-prop__value">{{ user.lastname }} {{ user.firstname }}</div>
        </div>
      </div>
      <div class="task__col">
        <h3 class="task-summary__title"></h3>

        <Priority
            :value="editable.task.priority"
            @update="v => setEditable('priority', v, 'task')"
        />
        <Tags
            :tags="editable.task.tags"
            @update="v => setEditable('tags', v, 'task')"
        />
      </div>
      <div class="task__col"></div>
      <div class="task__col"></div>
    </div>

    <SubtaskType
        class="task-task-type"
        :tasks="tasks"
        :active="editable.task.planTaskId"
        @typeChange="v => setEditable('planTaskId', v, 'task')"
    />

    <template v-if="editable.task.planTaskId">
      <StageNewListTable>
        <TaskNewStage
            :key="stage.tmpId"
            v-for="stage in editable.task.stages"
            :stages="editable.task.stages"
            :stage="stage"
            @update="updateStage"
            @delete="deleteStage"
        />
      </StageNewListTable>

      <div class="stage-new-list-foot">
        <a
            class="plan__subtask-type-add icon-text"
            @click.prevent="createNewStage">
          <Icon id="plus" size="26"/>
          <span>Добавить этап</span>
        </a>

        <div class="task-stream-count">
          <div class="task-stream-count__label">Кол-во подзадач:</div>
          <div class="task-stream-count__value">
            <input
                style="width: 55px"
                type="text"
                class="form-input"
                :value="editable.task.streamCount"
                @input="setEditable('streamCount', $event.target.value, 'task')"
                @blur="setEditable('streamCount', $event.target.value || 1, 'task')"
            >
          </div>
        </div>
      </div>

      <a class="btn btn-primary" href @click.prevent="createTask">Создать задачу</a>
    </template>

    <p v-if="saveErrors" class="error-txt">{{ saveErrors }}</p>
  </div>
</template>

<script>
import {mapState} from "vuex";
import editableMixin from "@/vue/share/editableMixin";
import Priority from "@/vue/plan/input/Priority";
import Tags from "@/vue/plan/input/Tags";
import Responsible from "@/vue/plan/input/Responsible";
import PlanTaskModel from "@/vue/plan/model/PlanTaskModel";
import StageName from "@/vue/plan/input/StageName";
import StageRelated from "@/vue/plan/input/StageRelated";
import StageDuration from "@/vue/plan/input/StageDuration";
import TaskNewStage from "@/vue/plan/url/TaskNewStage";
import SubtaskType from "@/vue/plan/input/SubtaskType";
import StageNewListTable from "@/vue/plan/url/Task/StageNewListTable";
import {endOfTheDay} from "@common/utils/date";
import PlanStageNewModel from "@/vue/plan/model/PlanStageNewModel";
import SelectSearch from "@common/vue/components/form/SelectSearch";

export default {
  name: "FormAddTask",
  mixins: [editableMixin],
  components: {
    SelectSearch,
    StageNewListTable,
    SubtaskType,
    TaskNewStage,
    StageDuration,
    StageRelated,
    StageName,
    Responsible,
    Tags,
    Priority,
  },
  props: ['url'],
  data() {
    const currentDate = endOfTheDay();

    return {
      editable: {
        task: new PlanTaskModel({
          planTaskId: 0,
          name: '',
          dateStart: currentDate,
          datePlanFinish: currentDate,
          urlId: 0,
          service: null,
        }),
      },
      isEditRun: false,
      activeRun: { label: '', id: 0 },
    };
  },
  computed: {
    ...mapState({
      user: state => state.common.authUser,
      tasks: state => state.planTemplate.taskList,
      stages: state => state.planUrlNew.newStages,
      saveErrors: state => state.planUrlAdd.saveErrors,
    }),
    saveError() {
      return Object.values(this.saveErrors).join('<br>\n');
    },
    corruptedFields() {
      return Object.keys(this.saveErrors);
    },
  },
  watch: {
    'editable.task.planTaskId': function() {
      this.fetchNewStages();
    },
  },
  created() {
    this.editable.task.set('ownerMyserId', this.user.id);
  },
  mounted() {
    this.$store.dispatch('fetchPlanUrlUsers');
    this.$store.dispatch('fetchPlanDataTemplate');
  },
  methods: {
    fetchNewStages() {
      this.$store.dispatch('fetchPlanNewUrlStages', {taskId: this.editable.task.planTaskId})
          .then(() => {
            const stages = this.stages
                .map(stage => stage.set('responsible', this.editable.task.myserId));
            this.setEditable('stages', stages, 'task');
          });
    },
    createTask() {
      this.$store.dispatch('createUrlTask', this.editable)
        .then((response) => {
          const {taskId, runId, service, urlId} = response.data;
          this.$emit('planTaskCreated', {taskId, runId, service, urlId});
        });
    },
    createNewStage() {
      this.setEditable('stages', [
        ...this.editable.task.stages,
        new PlanStageNewModel({myserId: this.editable.myserId}, 'create'),
      ], 'task');
    },
    updateStage({stageId, prop, value}) {
      const stages = [...this.editable.task.stages];
      const idx = stages.findIndex(s => s.getId() === stageId);

      stages[idx].set(prop, value);
      this.setEditable('stages', stages, 'task');
    },
    deleteStage(stageId) {
      this.setEditable('stages',
          [...this.editable.task.stages].filter(s => s.getId() !== stageId), 'task');
    },
  },
}
</script>

<style lang="scss">
@import "/resources/common/scss/abstracts/abstracts";

.mx-datepicker .cell.active {
  border-radius: 50%;
}

.task-summary {
  margin-bottom: 50px;
}

.task-task-type {
  margin: 0 0 50px;
  display: inline-flex;
  align-items: center;
  width: 460px;

  .component--select {
    flex: 1;
    margin-left: 15px;
  }
}

.stage {
  width: 100%;

  &__head {
    .stage__col {
      border-bottom: 1px solid $green;
      font-family: "Inter", sans-serif;
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      text-transform: uppercase;
      color: #000000;
    }
  }

  &__row {
    display: flex;
  }

  &__row_error {
    .stage__col {
      font-size: 75%;
      color: #FF0000;
    }
  }

  &__col {
    flex: 0 0 auto;
    width: 25%;
  }
}

.task-stream-count {
  display: flex;
  align-items: center;

  &__label {
    margin-right: 5px;
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }
}

.stage-new-list-foot {
  display: flex;
  width: 75%;
  margin-bottom: 55px;
  padding-right: 16px;

  .plan__subtask-type-add {
    flex: 0 0 auto;
    width: 280px;
    margin-right: 15px;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #30B68F;
  }
}

.task-summary__title {
  [aria-invalid] {
    border-color: red;
  }
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style lang="scss">
#form-task-new {
  .run-block .dropdown__body {
    width: 230px;
  }
}
</style>

